import { Escalation } from '@/types/doctorManagementTypes';
import React from 'react';

interface EscalationIssueHeadingProps {
  data: Escalation | undefined;
}

const EscalationIssueHeading = ({ data }: EscalationIssueHeadingProps) => {
  if (!data) return null;

  const filteredEntries = Object.entries(data).filter(([key]) =>
    ['issue', 'escalatedBy'].includes(key)
  );

  return (
    <div className="flex justify-end items-center mx-12 gap-4 mt-3 mb-7 bg-rose-50 p-5 rounded-md">
      {filteredEntries.map(([key, value], index) => (
        <React.Fragment key={index}>
          <p className="text-sm">
            <span>
              {key.charAt(0).toUpperCase() +
                key.slice(1).replace(/([A-Z])/g, ' $1')}
              :
            </span>{' '}
            <strong>{value}</strong>
          </p>
          {index < filteredEntries.length - 1 && <span className="mx-1">|</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default EscalationIssueHeading;
